import type {
	DateCalendar,
	HandleErrors,
	UtilitiesTranslations,
} from "Infrastructure/Translation/Types/utilities";

const calendarTranslations: DateCalendar = {
	todayAt: "Today at",
	tomorrowAt: "Tomorrow at",
	nextWeekDayAt: "Next",
	yesterdayAt: "Yesterday at",
	lastWeekDayAt: "Last",
	at: "at",
};

const handleErrorsTranslations: HandleErrors = {
	reviewFields: "Please review the fields",
};

export const utilitiesTranslations: UtilitiesTranslations = {
	calendar: calendarTranslations,
	handleErrors: handleErrorsTranslations,
};
